import React from "react";
import UserSearchTagPicker from "../../../../../components/ui/UserSearchTagPicker";

// Adaptateur UserSearchTagPicker <-> formData.userIds.
//
// IMPORTANT : contrairement à tout le reste de l'app, formData.userIds ici
// contient des EMAILS (pas des ids numériques) — c'est ce qui est envoyé tel
// quel en `userEmails` à /api/email-arrivepc, /api/email-tri, /api/email-tri1,
// /api/email-tri2, /api/email-bouclage. UserSearchTagPicker attend des
// `selectedIds` numériques (user.id), donc on convertit uniquement à
// l'affichage, sans jamais changer ce qui est stocké dans formData.userIds.
function NotifyPicker({ allUsers, formData, setFormData }) {
  const selectedUserIdsForPicker = allUsers
    .filter((u) => formData.userIds.includes(u.email))
    .map((u) => u.id);

  const handleAdd = (user) => {
    setFormData((prev) =>
      prev.userIds.includes(user.email)
        ? prev
        : { ...prev, userIds: [...prev.userIds, user.email] }
    );
  };

  const handleRemove = (id) => {
    const u = allUsers.find((x) => x.id === id);
    if (!u) return;
    setFormData((prev) => ({
      ...prev,
      userIds: prev.userIds.filter((email) => email !== u.email),
    }));
  };

  return (
    <UserSearchTagPicker
      allUsers={allUsers}
      label="Personne(s) à notifier"
      selectedIds={selectedUserIdsForPicker}
      onAdd={handleAdd}
      onRemove={handleRemove}
    />
  );
}

export default NotifyPicker;
